import React, { useEffect, useState } from "react";
import styles from "./home.module.scss";
// import { useIntl, history, useModel } from 'umi';
import Layout from "../../layouts/User";
import Privacy from "../../layouts/User/privacyNotice";
import { ONETRUST_PRIVACY_POLICY_URL } from "../../config";

export type Props = {};

const breadcrumbs = [
  {
    text: "หน้าแรก",
    path: "/",
  },
  {
    text: "นโยบายความเป็นส่วนตัว",
  },
];
const PrivacyNotice: React.FC<Props> = (props) => {
  const [notices, setNotices] = useState<any>();

  useEffect(() => {
    let script3 = document.createElement("script");
    script3.setAttribute(
      "src",
      "https://privacyportal-apac-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js"
    );
    script3.setAttribute("type", "text/javascript");
    script3.setAttribute("charset", "UTF-8");
    script3.setAttribute("id", "otprivacy-notice-script");
    script3.async = true;
    script3.innerHTML = `settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC1hcGFjLm9uZXRydXN0LmNvbS9yZXF1ZXN0L3YxL3ByaXZhY3lOb3RpY2VzL3N0YXRzL3ZpZXdzIn0="`;
    document.head.appendChild(script3);
    // **** UAT START ****
    // const ONETRUST_PROVACTY_POLICY = `https://privacyportal-uat-cdn.onetrust.com/669247f0-b028-4f7e-a819-5e780546ba06/privacy-notices/draft/c9e0a095-10ca-4969-8b5a-694beb4cc794-th-th.json`;
    // **** UAT END ****
    // **** PRODUCTION START ****
    // const ONETRUST_PROVACTY_POLICY = `https://privacyportal-uat-cdn.onetrust.com/669247f0-b028-4f7e-a819-5e780546ba06/privacy-notices/draft/c9e0a095-10ca-4969-8b5a-694beb4cc794-th-th.json`;
    // **** PRODUCTION END ****
    const ONETRUST_PROVACTY_POLICY = `${ONETRUST_PRIVACY_POLICY_URL}`;
    fetch(ONETRUST_PROVACTY_POLICY)
      .then((response) => response.json())
      .then((jsonData) => {
        // jsonData is parsed json object received from url
        const aaaa = jsonData.notices[Object.keys(jsonData.notices)[0]];

        setNotices(aaaa.content);
      })
      .catch((error) => {
        // handle your errors here
        console.error(error);
      });
  }, []);
  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
        <div className={styles.wrapper}>
          <div className={styles.topBody} style={{ marginTop: 70 }}></div>
        </div>
        <div
          id="otnotice-f4d306bf-5d80-428d-be47-d8e406eeec9a"
          className="otnotice"
          dangerouslySetInnerHTML={{
            __html: notices,
          }}
        ></div>
      </Layout>
    </>
  );
};
export default PrivacyNotice;
